import { useContext, useMemo, useState } from 'react';

import { Popover, Image } from 'antd';

import SvgIcon from '@/components/SvgIcon';
import { LayoutContext } from '@/layouts/baseLayout/provider';

const fallbackImg = 'https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif';
const loadingImg = 'https://static.szlcsc.com/ecp/assets/web/common/images/loading_logo.jpg';

export default function PicturePerview(props) {
  const { src, width = 105, height = 105, imageList = [], alt, productId } = props;

  const [open, setOpen] = useState(false);

  function openChange(value) {
    if (!src || src === fallbackImg) {
      return;
    }
    setOpen(value);
  }

  return (
    <Popover
      open={open}
      placement="right"
      content={<Content imageList={imageList} productId={productId} />}
      onOpenChange={openChange}
      overlayClassName="lcsc-popover-wrapper"
      showArrow={false}
      align={{
        offset: [-4, 0],
      }}
    >
      <Image
        fallback={fallbackImg}
        alt={alt}
        src={src || fallbackImg}
        width={width}
        height={height}
        preview={false}
        loading="lazy"
        placeholder={<LoadingImg width={width} height={height} />}
        style={{ borderRadius: '4px', overflow: 'hidden', marginBottom: '12px' }}
      />
    </Popover>
  );
}

// 加载中图片
export function LoadingImg(props) {
  const { width = 105, height = 105 } = props;

  return <Image src={loadingImg} width={width} height={height} preview={false} alt={'loading占位图'}></Image>;
}

// 悬浮框内容
function Content(props) {
  const { imageList = [], productId } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const { resourceData } = useContext(LayoutContext);

  // 上一组图片
  function goPerv() {
    if (activeIndex === 0) {
      setActiveIndex(imageList.length - 1);
      return;
    }
    setActiveIndex(activeIndex - 1);
  }

  // 下一组图片
  function goNext() {
    if (activeIndex === imageList.length - 1) {
      setActiveIndex(0);
      return;
    }
    setActiveIndex(activeIndex + 1);
  }

  const bigImage = useMemo(() => {
    if (imageList?.length > 0) {
      return imageList[activeIndex].replace('product/breviary', 'product/source');
    }
    return '';
  }, [activeIndex, imageList]);

  return (
    <div
      className="select-none rounded-[5px] border-[1px] border-solid border-[#DEDEDE] p-[10px_10px_15px_10px]"
      data-spm="xtp"
    >
      <a
        className="block overflow-hidden rounded-[5px]"
        title="点击查看大图"
        target="_blank"
        href={`${resourceData?.projectConfigVO?.lcscItemUrl}/product/jpg_${productId}.html`}
        data-spm="a"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <Image
          src={bigImage}
          width={305}
          height={305}
          fallback="https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif"
          preview={false}
          placeholder={<LoadingImg width={305} height={305} />}
        />
      </a>
      <div className="mt-[8px] flex items-center justify-between">
        <SvgIcon
          app="so"
          iconName="arrow-left"
          className="h-[28px] w-[14px] rotate-[180deg] cursor-pointer text-[#D9D9D9] hover:text-[#1FA0E8]"
          title="上一组图片"
          onClick={goPerv}
        ></SvgIcon>
        <ul className="flex items-center">
          {imageList?.map((item, index) => (
            <li
              className={`mx-[5px] box-border flex h-[50px] w-[50px] cursor-pointer items-center justify-center overflow-hidden rounded-[5px] border-solid
              ${activeIndex === index ? 'border-[2px] border-[#0093e6]' : ''}`}
              key={index}
              onClick={() => {
                setActiveIndex(index);
              }}
            >
              <Image
                src={item}
                width={50}
                height={50}
                fallback="https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif"
                preview={false}
                placeholder={<LoadingImg width={50} height={50}></LoadingImg>}
              />
            </li>
          ))}
        </ul>
        <SvgIcon
          app="so"
          iconName="arrow-left"
          className="h-[23px] w-[13px] cursor-pointer text-[#D9D9D9] hover:text-[#1FA0E8]"
          title="下一组图片"
          onClick={goNext}
        ></SvgIcon>
      </div>
      <div className="mt-[12px] text-center text-[12px] text-[#9a9a9a]">温馨提醒：图片仅供参考，商品以实物为准</div>
    </div>
  );
}
